export const PayLinkExpired = () => {
  return (
    <div className="absolute flex h-full w-full justify-center">
      <div className="h-fit w-fit max-w-lg self-center text-primary-10">
        <h1 className="text-2xl font-med">This pay link has expired</h1>
        <h2 className="text-l font-reg">
          This pay link is no longer active. Please contact the merchant if you
          wish to pay via iwocaPay.
        </h2>
      </div>
    </div>
  );
};
